import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultState", "confirmState"]

  connect() {
    this.resetTimer = null
  }

  confirm() {
    this.defaultStateTarget.classList.add("hidden")
    this.confirmStateTarget.classList.remove("hidden")

    this.resetTimer = setTimeout(() => {
      this.cancel()
    }, 3000)
  }

  cancel() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer)
      this.resetTimer = null
    }

    this.confirmStateTarget.classList.add("hidden")
    this.defaultStateTarget.classList.remove("hidden")
  }

  disconnect() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer)
    }
  }
}
